
































































import { Component, Vue, Watch } from "vue-property-decorator";
import User from "@/model/user";
import userApi from "@/api/userApi";
@Component({
  name: "accountSearch",
})
export default class PartnerSearch extends Vue {
  public isShow = false;
  public user: User = new User();
  public email = "";

  public show() {
    this.email = "";
    this.user = new User();
    this.isShow = true;
  }

  public async doSearch() {
    if(this.email.trim() == '') {
      this.user = new User();
      return;
    }

    const result = await userApi.index({
      email: this.email
    });
    this.user = result[0] ? result[0] : new User();
  }

  public insertUserId(id) {
    this.$emit('insertUserId', id)
    this.isShow = false;
  }

  @Watch('isShow')
  public checkDisplayModal() {
    if (this.isShow) {
      document.documentElement.style.overflow = 'hidden';
    } else {
      document.documentElement.style.overflow = 'auto';
    }
  }
}
